import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import LicenceBillingCSP from "../../../models/csp/LicenceBillingCSP";
import licenceBillingService from "../../../services/csp/licenceBillingService";
import { RootState } from "../../index";

const namespaced = true;

interface LicenceBillingState {
  licencesBillings: LicenceBillingCSP[];
}

const state: LicenceBillingState = {
  licencesBillings: []
};

const mutations: MutationTree<LicenceBillingState> = {
  setLicencesBillings(state, licencesBillings: LicenceBillingCSP[]) {
    state.licencesBillings = licencesBillings;
  }
};

const actions: ActionTree<LicenceBillingState, RootState> = {
  async loadLicencesBillingsCSP({ commit }, id: string) {
    const licencesBillings: LicenceBillingCSP[] =
      await licenceBillingService.methods.getLicencesBillingsCSP(id);
    commit("setLicencesBillings", licencesBillings);
  }
};

const getters: GetterTree<LicenceBillingState, RootState> = {
  getLicencesBillingCSPBySubscriptionId:
    state =>
    (id: string): LicenceBillingCSP => {
      return state.licencesBillings.find(
        licence => licence.getSubscriptionId == id
      );
    }
};

export const licenceBillingModuleCSP: Module<LicenceBillingState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
